import MainHeading from "../../components/comman/MainHeading";
import { useEffect, useState } from "react";
import { callApi } from "../../ApiHelper/ApiHelper";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import moment from "moment";
import PaginationComponent from "../../components/comman/PaginationComponent";
import NoRecordIcon from "../../components/Icons/NoRecordIcon";

export default function Logs({ type, id, refreshLogs, setRefreshLogs, name, showBackButton }) {
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    logsData: [],
  });

  const GetLogsData = () => {
    let API = `${apiUrl?.get_logs}?pageNumber=${pageStates?.currentPage}&pageSize=${pageStates?.pageSize}&type=${type}&id=${id}`;
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(API, { method: "GET" }).then((response) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (setRefreshLogs) {
        setRefreshLogs(false);
      }
      if (response?.status) {
        setPageStates((pre) => ({
          ...pre,
          logsData: response?.data?.logs || [],
          totalPages: response?.data?.pageInfo?.totalPages,
          count: response?.data?.pageInfo?.total,
        }));
      } else {
        setPageStates((pre) => ({
          ...pre,
          logsData: [],
        }));
      }
    });
  };

  useEffect(() => {
    GetLogsData();
  }, [pageStates?.currentPage, refreshLogs]);

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  return (
    <div className="content">
      <MainHeading showBackButton={showBackButton} title={name ? name + "'s Logs" : "Logs"} />
      <div className="card">
        <div className="card-body">
          <div className={pageStates?.tableLoader ? "loading-skeleton" : ""}>
            {pageStates?.tableLoader ? (
              <>
                {[1].map((_, index) => (
                  <div
                    key={`skeleton-${index}`}
                    className="card mb-3 shadow-sm border-light"
                  >
                    <div className="card-body">
                      <div
                        className="skeleton-placeholder"
                        style={{ height: "60px", width: "100%" }}
                      >
                        ....
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : pageStates?.logsData?.length > 0 ? (
              pageStates.logsData.map((log, index) => (
                <div key={index} className="card mb-2 shadow-sm border-light">
                  <div className="card-body">
                    <h5 className="card-title fw-bold mb-2">{log?.text}</h5>
                    <p className="card-text text-muted mb-0 fs-5">
                      {moment(log?.createdAt).format("DD MMM YYYY, hh:mm A")}
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center text-muted py-4">
                <div className="d-flex flex-column justify-content-center align-items-center no-data-error">
                  <NoRecordIcon />
                  <span>No Logs Available</span>
                </div>
              </div>
            )}
          </div>

          <PaginationComponent
            currentPage={pageStates?.currentPage}
            PageChangeHandler={PageChangeHandler}
            totalPages={pageStates?.totalPages}
          />
        </div>
      </div>
    </div>
  );
}
